import '../../../../../../d3-color/src/color.js';
import '../../../../../../d3-color/src/lab.js';
import cubehelix from '../../../../../../d3-color/src/cubehelix.js';
import '../../../d3-interpolate/src/rgb.js';
import '../../../d3-interpolate/src/zoom.js';
import { cubehelixLong } from '../../../d3-interpolate/src/cubehelix.js';
cubehelixLong(cubehelix(300, 0.5, 0.0), cubehelix(-240, 0.5, 1.0));
//# sourceMappingURL=cubehelix.js.map
